import { render, staticRenderFns } from "./QnaCreate.vue?vue&type=template&id=b615abca&scoped=true"
import script from "./QnaCreate.vue?vue&type=script&lang=js"
export * from "./QnaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b615abca",
  null
  
)

export default component.exports